<template>
    <div class="detail-table" v-if="price">
        <table>
            <thead>
            <tr>
                <th>試験名</th>
                <th>受験料</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>急性期ケア専門士模擬試験</td>
                <td>￥{{ price.amount.toLocaleString() }}</td>
            </tr>
            <tr>
                <td>送料</td>
                <td>￥{{ price.shipping.toLocaleString() }}</td>
            </tr>
            <tr>
                <td>手数料</td>
                <td>￥{{ price.fee.toLocaleString() }}</td>
            </tr>
            <tr>
                <td>小計</td>
                <td>￥{{ price.total_without_tax.toLocaleString() }}</td>
            </tr>
            <tr>
                <td>消費税</td>
                <td>￥{{ price.tax.toLocaleString() }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td>合計</td>
                <td>￥{{ price.total.toLocaleString() }}</td>
            </tr>
            </tfoot>
        </table>
    </div>
    <div v-else-if="isSelected" class="p-2">
        ご注文を確認中です・・・
    </div>
    <div v-else class="text-red-500 p-2">
        お支払い方法を選択してください。
    </div>
</template>

<script>
export default {
    name: "ApplyDetailTable",

    props: {
        price: {
            type: Object
        },
        isSelected: {
            type: Boolean
        }
    }
}
</script>

<style scoped>

</style>
